import type { IAttachment } from '@/interfaces/IAttachment'

class Attachment implements IAttachment {
  path?: string
  type?: string

  constructor(attachment: any) {
    this.path = attachment?.path
    this.type = attachment?.type
  }
}

export default Attachment
